import {useDefaultEndpoints} from "./useDefaultEndpoints";

export const useGroupsApi = (isFormData = false) => {
    return {
        ...useDefaultEndpoints('groups', isFormData)
    }
};